import styled, { css } from 'styled-components';
import Select from 'react-select';
import ThemedTooltip from '../../../../../../theme/ThemedTooltip';
import { InfoDark } from '../../../../../../globalStyled';

export const StyledCellName = styled.span`
  color: ${({ theme }) => theme.textFaint};
  padding: 7px 0;
`;
export const StyledCell = styled.span`
  font-size: 11px;
  font-weight: 500;
  font-family: 'Archivo', sans-serif;
  color: ${({ theme }) => theme.text};
`;
export const InfoDarkAbsolute = styled(InfoDark)`
  position: relative;
  top: 1px;
  left: 2px;
`;

export const StyledNumber = styled.span`
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledTableContainer = styled.section`
  width: 100%;
  margin-top: 20px;
  overflow: auto;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  padding: 4px 12px 12px;
  > h1 {
    margin-bottom: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: 'Archivo', sans-serif;
    font-style: normal;
    font-size: 25px;
    font-weight: bold;
    line-height: 41px;
    letter-spacing: normal;
    color: ${({ theme }) => theme.text};
    text-align: left;
    text-transform: none;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-style: hidden;
`;

export const StyledThead = styled.thead`
  ${({ display }) => {
    if (display === 'none')
      return css`
        display: none;
      `;
  }}
`;

export const StyledTbody = styled.tbody`
  &::before {
    content: '';
    display: block;
    height: 0px;
  }
`;

export const StyledTrTh = styled.tr``;

export const StyledTh = styled.th`
  padding: 6px 0 6px 12px;
  background: transparent;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 26px;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.textFaint};
  text-align: left;

  @media screen and (max-width: 768px) {
    font-size: 11px;
    &[type='Deal type'],
    &[type='Amount'] {
      display: none;
    }
  }

  &:first-of-type {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 0px;
  }
  &:last-of-type {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 0px;
  }
`;

export const StyledTrTd = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  background: transparent;
  &:hover {
    background: ${({ theme }) => theme.hover};
  }

  &:last-of-type {
    border-bottom: 0;
    td {
      &:first-child {
        border-bottom-left-radius: 5px;
      }
      &:last-child {
        border-bottom-right-radius: 5px;
      }
    }
  }
`;

export const StyledTd = styled.td`
  text-align: left;
  padding: 12px 10px;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.text};
  width: 80px;
  line-height: 1;
  ${({ pointerCursor }) => {
    if (pointerCursor)
      return css`
        cursor: pointer;
        text-decoration: underline;
      `;
  }}

  ${({ titleCell, type }) => {
    if (titleCell)
      return css`
        text-align: left;
      `;
    if (type === 'Deal type' || type === 'Amount') {
      return css`
        @media screen and (max-width: 768px) {
          display: none;
        }
      `;
    }
  }}
`;

export const StyledRatingCell = styled.div`
  position: relative;
  width: 120px;
  margin: 0 auto;
  /*  @media (max-width: 530px) {
    width: 100px;
  } */
`;

export const StyledRowNumber = styled.span`
  max-width: 50px;
`;

export const StyledLifetimeCell = styled.div`
  position: relative;
  margin: 0 auto;
`;

export const StyledChartContainer = styled.div`
  padding: ${({ small }) => (small ? '0px' : '15px 20px')};
  display: flex;
  flex-direction: row;
  justify-content: start;
`;

export const StyledSelect = styled(Select)`
  background-color: transparent;

  font-size: 13px;
  .react-select__control {
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.06));
    min-height: 25px;
    background-color: transparent;
    border: 0;
    font-weight: 700;
    box-shadow: none;
  }

  .react-select__placeholder {
    font-family: 'Archivo', sans-serif;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0px;
    color: ${({ theme }) => theme.textFaint};
  }
  .react-select__option {
    font-family: 'Archivo', sans-serif;
    padding: 8px 10px;
  }
  .react-select__indicator {
    padding: 0;
    position: relative;
    svg {
      display: none;
    }
    &:before {
      display: block;
      content: ' ';
      width: 0;
      height: 0;
      opacity: 0.5;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;

      border-top: 4px solid ${({ theme }) => theme.text};
    }
  }
  .react-select__value-container {
    width: 30px;
    padding: 3px;
  }
  .react-select__indicator-separator {
    display: none;
  }
`;

export const StyledSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    font-size: 13px;
  }
`;

export const StyledPagination = styled.div`
  display: flex;
  flex-direction: row;
  height: 25px;
  justify-content: flex-end;
  margin-top: 30px;
`;

export const ArrowRight = styled.i`
  border: solid ${({ theme }) => theme.text};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
`;
export const ArrowLeft = styled.i`
  border: solid ${({ theme }) => theme.text};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
  transform: rotate(-225deg);
`;

export const StyledPaginationButton = styled.button`
  border: 0;
  box-shadow: none;
  background-color: transparent;
  color: ${({ theme }) => theme.text};
  border-radius: 3px;
  align-self: center;
  display: flex;
  flex-direction: row;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;
export const StyledPageNumber = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20px;
`;

export const StyledPageLabel = styled.span`
  font-size: 13px;
  margin: 0 10px;
`;

export const StyledReactTooltip = styled(ThemedTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  font-family: Archivo;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.border};
  width: 190px;
  &.__react_component_tooltip.show {
    color: ${({ theme }) => theme.text};
    font-size: 13px;
    line-height: 18px;
    border-radius: 6px;
    opacity: 1;
  }
`;

export const StyledTooltipContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
`;

export const StyledTopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  padding: 10px 15px;
`;

export const StyledBottomSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 15px;
`;

export const StyledMobileSection = styled.div`
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 11px;
  text-align: center;
`;

export const StyledTitle = styled.span`
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.13px;
`;

export const StyledSortSelect = styled(Select)`
  display: none;

  .react-select__control {
    background-color: ${({ theme }) => theme.card};
    color: ${({ theme }) => theme.text};
    border: 1px solid ${({ theme }) => theme.border};
    width: 100%;
  }
  .react-select__indicator-separator {
    display: none;
  }
  .react-select__menu {
    z-index: 2;
  }

  .react-select__placeholder {
    font-family: 'Archivo', sans-serif;
    font-size: 14.222px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.textFaint};
  }
  .react-select__option {
    font-family: 'Archivo', sans-serif;
  }
`;

export const StyledSortContainer = styled.div`
  display: none;
`;
export const SortLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  font-family: 'Archivo', sans-serif;
`;

export const StyledDealsPlayerName = styled.span``;

export const StyledDealStatus = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${({ $color, theme }) => $color || theme.textFaint};
  svg {
    display: block;
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
`;

export const StyledStatusFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 12px;
`;

export const StyledStatusChip = styled.button`
  font-family: 'Archivo', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 7px 12px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ $active, theme }) => ($active ? theme.hover : 'transparent')};
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: ${({ theme }) => theme.hover};
  }
`;

export const StyledMakeOfferButton = styled.button`
  font-family: 'Archivo', sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.text};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: ${({ theme }) => theme.hover};
  }
`;
